<template>
  <v-layout row>
    <v-flex
      d-flex
      md12
    >
      <v-card>
        <v-form>
          <v-container>
            <v-layout row>
              <v-flex md2>
                <v-text-field
                  v-model="name"
                  label="社名"
                />
              </v-flex>
              <v-flex md2>
                <v-text-field
                  v-model="tel"
                  label="電話番号"
                />
              </v-flex>
              <v-flex
                offset-md6
                md2
              >
                <v-btn
                  :to="{ name: '提携企業登録', params: { id: 'new' } }"
                  color="success"
                >
                  追加
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: () => ({
    name: '',
    tel: ''
  })
}
</script>
